<template>
  <div class="page-wrap">
    <div class="block">
      <el-date-picker value-format="yyyyMM" v-model="searchdate" type="month" placeholder="请选择月" @change="changeData"> </el-date-picker>
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="monthDate" label="日期" width="180"> </el-table-column>
        <el-table-column prop="checkRange" label="校验范围"> </el-table-column>
        <el-table-column prop="errorRange" label="误差范围">
          <template slot-scope="scope">
            {{ (scope.row.errorRange * 100).toFixed(2) + "%" }}
          </template>
        </el-table-column>
        <el-table-column prop="report" label="校验报告" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="viewReport(scope.row)">查看报告</el-button>
          </template>
        </el-table-column>
      </el-table>
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        ref="tabelPagination"
        @getCurrentPage="changePage"
        @handleSizeChange="changePageSize"
      ></self-pagination>
    </div>
    <el-dialog title="校验报告" :visible.sync="dialogVisible" width="800px" center :close-on-click-modal="false">
      <div class="modal-content">
        <div class="title">数据条件</div>
        <el-table :data="rangeData" border style="width: 100%" size="mini">
          <el-table-column prop="range" label="数据范围"> </el-table-column>
          <el-table-column prop="product" label="产品包（个）"> </el-table-column>
          <el-table-column prop="record" label="记录（条）"> </el-table-column>
        </el-table>
        <el-table :data="dimensionData" border style="width: 100%;margin-top: 16px" size="mini">
          <el-table-column prop="dimension" label="聚合维度"> </el-table-column>
          <el-table-column prop="number" label="数量（个）"> </el-table-column>
        </el-table>
        <div class="title">校验结果</div>
        <el-table class="result-table" :data="resultData" border style="width: 100%;" size="mini">
          <el-table-column prop="country" width="160" label="180日累计偏差均值"> </el-table-column>
          <el-table-column prop="channel" label=""> </el-table-column>
          <el-table-column prop="plan" label=""> </el-table-column>
          <el-table-column prop="granularity" label=""> </el-table-column>
        </el-table>
        <div class="charts-area" ref="chartRef"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { getViditionData } from "@/api/api";
export default {
  data() {
    return {
      searchdate: "",
      tableData: [],
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      dialogVisible: false,
      predictionData: {},
      rangeData: [],
      dimensionData: [],
      resultData: [],
      myChart: null,
    };
  },

  computed: {
    echartData() {
      var obj = {};
      var arr = [];
      for (let key in this.predictionData.data_error_dict) {
        arr.push(Number(key.split("e")[1])); // 集合所有的key
      }
      arr.sort((a, b) => {
        return a - b;
      });
      arr.forEach((item) => {
        obj["e" + item] = this.floatMul(this.predictionData.data_error_dict["e" + item], 100);
      });
      return Object.values(obj);
    },
  },

  watch: {},

  mounted() {
    this.getViditionData();
  },

  methods: {
    floatMul(a, b) {
      var c = 0,
        d = a.toString(),
        e = b.toString();
      try {
        c += d.split(".")[1].length;
      } catch (f) {
        console.log();
      }
      try {
        c += e.split(".")[1].length;
      } catch (f) {
        console.log();
      }
      return (Number(d.replace(".", "")) * Number(e.replace(".", ""))) / Math.pow(10, c);
    },
    changePage(page) {
      this.pageData.page = page;
      this.getViditionData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getViditionData();
    },
    changeData() {
      this.pageData.page = 1;
      this.getViditionData();
    },
    getViditionData() {
      getViditionData({
        size: this.pageData.size,
        pageSize: this.pageData.page,
        searchDate: this.searchdate,
      }).then((res) => {
        if (res.code === "0000") {
          this.pageData.total = res.data.total;
          this.tableData = res.data.list;
        }
      });
    },
    viewReport(data) {
      this.dialogVisible = true;
      this.predictionData = JSON.parse(data.predictionData);
      const {
        data_ori_count,
        pkg_ori_count,
        data_filtered_count,
        pkg_filtered_count,
        geo_filterer_count,
        source_filterer_count,
        campaign_filterer_count,
        data_avg_error,
        geo_avg_error,
        mediasource_avg_error,
        campaign_avg_error,
      } = this.predictionData;
      (this.rangeData = [
        { range: "原始校验数据", product: pkg_ori_count, record: data_ori_count },
        { range: "过滤用户小于200的记录", product: pkg_filtered_count, record: data_filtered_count },
      ]),
        (this.dimensionData = [
          { dimension: "国家地区", number: geo_filterer_count },
          { dimension: "渠道", number: source_filterer_count },
          { dimension: "买量计划", number: campaign_filterer_count },
        ]),
        (this.resultData = [
          { country: "国家地区", channel: "渠道", plan: "买量计划", granularity: "最细粒度" },
          {
            country: (geo_avg_error * 100).toFixed(2) + "%",
            channel: (mediasource_avg_error * 100).toFixed(2) + "%",
            plan: (campaign_avg_error * 100).toFixed(2) + "%",
            granularity: (data_avg_error * 100).toFixed(2) + "%",
          },
        ]),
        this.$nextTick(() => {
          let chartDom = this.$refs.chartRef;
          let myChart = echarts.init(chartDom);
          window.onresize = myChart.resize;
          this.myChart = myChart;
          this.renderData();
        });
    },
    renderData() {
      let option = {
        title: {
          text: "180日累计偏差百分比各层次比例", // 标题
          x: "center",
          y: "20px",
          textStyle: {
            color: "rgba(0, 0, 0, 0.85)",
            fontSize: 14,
          },
          textAlign: "left",
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            let tip = params[0].name;
            for (let i = 0; i < params.length; i++) {
              tip = params[i].name + "" + params[i].seriesName + ": " + params[i].value + "%";
            }
            return tip;
          },
        },
        xAxis: {
          type: "category",
          axisLabel: {
            interval: 0,
            rotate: 40, //x轴文字倾斜角度
            textStyle: {
              fontSize: 10,
              marginLeft: 22,
            },
          },
          data: [
            "小于-100%",
            "-100%至-50%",
            "-50%至-40%",
            "-40%至-30%",
            "-30%至-20%",
            "-20%至-15%",
            "-15%至-10%",
            "-10%至-5%",
            "-5%至0%",
            "0%至5%",
            "5%至10%",
            "10%至15%",
            "15%至20%",
            "20%至30%",
            "30%至40%",
            "40%至50%",
            "50%至100%",
            "大于100%",
          ],
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: function(value) {
              return value + "%";
            },
          },
        },
        series: [
          {
            name: "比例",
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            itemStyle: {
              color: (params) => {
                // 定义一个颜色数组colorList
                var colorList = [
                  "#aafe31C",
                  "#016503",
                  "#fd4704",
                  "#fc8c03",
                  "#ec827f",
                  "#02ff81",
                  "#1fb1a9",
                  "#00fefd",
                  "#00befc",
                  "#4483b3",
                  "#768998",
                  "#406ae1",
                  "#191b70",
                  "#bba5d5",
                  "#cca272",
                  "#74608f",
                  "#d7a02b",
                  "#c8ba23",
                ];
                return colorList[params.dataIndex];
              },
            },
            //柱状图宽度
            barWidth: "60%",
            //柱状图数值
            data: this.echartData,
          },
        ],
      };
      this.myChart.clear();
      this.myChart.setOption(option);
    },
    handerConfirm() {},
  },
};
</script>

<style lang="less" scoped>
.block {
  margin-bottom: 16px;
}
.modal-content {
  max-height: 666px;
  overflow-y: auto;
  overflow-x: hidden;
  .title {
    padding: 16px 16px 16px 0px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .result-table {
    /deep/ th {
      border-right: none;
    }
  }
  .charts-area {
    height: 400px;
  }
}
</style>
